export const CUSTOM_ROTATION_CONTROL_ID = 'custom-rotation-control';
export const CUSTOM_ROTATE_CONTROL_MARGIN = 30;
